import React, { useState, useEffect } from "react";
import ColorPicker from "../../../components/ColorPicker";
import CssCodeEditor from "../../../components/CssCodeEditor";

const StyleTab = ({updateInstagramFeedTabData,instagramFeedTabData}) => {
    const [activeSettingTab, setActiveSettingTabsElements] = useState("main");
    const [headerBackgroundColor, setHeaderBackgroundColor] = useState(instagramFeedTabData.header_background_color);
    const [headerTextColor, setHeaderTextColor] = useState(instagramFeedTabData.header_text_color);
    const [headerFollowButtonColor, setHeaderFollowButtonColor] = useState(instagramFeedTabData.header_follow_button_color);
    const [headerFollowButtonTextColor, setHeaderFollowButtonTextColor] = useState(instagramFeedTabData.header_follow_button_text_color);
    const [postOverlayBackgroundColor, setPostOverlayBackgroundColor] = useState(instagramFeedTabData.header_post_overlay_background);
    const [postOverlayTextColor, setPostOverlayTextColor] = useState(instagramFeedTabData.header_post_overlay_text);
    const [loadMoreButtonColor, setLoadMoreButtonColor] = useState(instagramFeedTabData.load_more_button);
    const [popupColorOverlayColor, setPopupColorOverlayColor] = useState(instagramFeedTabData.popup_color_overlay);
    const [popupBackgroundColor, setPopupBackgroundColor] = useState(instagramFeedTabData.popup_background_color);
    const [popupTextColor, setPopupTextColor] = useState(instagramFeedTabData.popup_text_color);
    const [popupLinksColor, setPopupLinksColor] = useState(instagramFeedTabData.popup_links_color);
    const [popupFollowButtonColor, setPopupFollowButtonColor] = useState(instagramFeedTabData.popup_follow_button_color);
    const [popupActionButtonColor, setPopupActionButtonColor] = useState(instagramFeedTabData.popup_action_button_color);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(instagramFeedTabData.style_custom_css);
   
    // Handlers Header Background Color Change
    const handleHeaderBackgroundColorChange = (color) => {
        setHeaderBackgroundColor(color.hex);
        updateInstagramFeedTabData("header_background_color", color.hex);
    };

    // Handlers header Text Color Change
    const handleHeaderTextColorChange = (color) => {
        setHeaderTextColor(color.hex);
        updateInstagramFeedTabData("header_text_color", color.hex);
    };

    // Handlers Header Follow Button Color Change
    const handleHeaderFollowButtonColorChange = (color) => {
        setHeaderFollowButtonColor(color.hex);
        updateInstagramFeedTabData("header_follow_button_color", color.hex);
    };

    // Handlers Header Follow Button Text Color Change
    const handleHeaderFollowButtonTextColorChange = (color) => {
        setHeaderFollowButtonTextColor(color.hex);
        updateInstagramFeedTabData("header_follow_button_text_color", color.hex);
    };

    // Handlers Post Overlay Background Color Change
    const handlePostOverlayBackgroundColorChange = (color) => {
        setPostOverlayBackgroundColor(color.hex);
        updateInstagramFeedTabData("header_post_overlay_background", color.hex);
    };

    // Handlers Post Overlay Text Color Change
    const handlePostOverlayTextColorChange = (color) => {
        setPostOverlayTextColor(color.hex);
        updateInstagramFeedTabData("header_post_overlay_text", color.hex);
    };

    // Handlers Load More ButtonColor Change
    const handleLoadMoreButtonColorChange = (color) => {
        setLoadMoreButtonColor(color.hex);
        updateInstagramFeedTabData("load_more_button", color.hex);
    };

    // Handlers Popup Color Overlay Color Change
    const handlePopupColorOverlayChange = (color) => {
        setPopupColorOverlayColor(color.hex);
        updateInstagramFeedTabData("popup_color_overlay", color.hex);
    };

    // Handlers Popup Background Color Change
    const handlePopupBackgroundColorChange = (color) => {
        setPopupBackgroundColor(color.hex);
        updateInstagramFeedTabData("popup_background_color", color.hex);
    };

    // Handlers Popup Text Color Change
    const handlePopupTextColorChange = (color) => {
        setPopupTextColor(color.hex);
        updateInstagramFeedTabData("popup_text_color", color.hex);
    };

    // Handlers Popup Links Color Change
    const handlePopupLinksColorChange = (color) => {
        setPopupLinksColor(color.hex);
        updateInstagramFeedTabData("popup_links_color", color.hex);
    };

    // Handlers Popup Follow Button Color Change
    const handlePopupFollowButtonColorChange = (color) => {
        setPopupFollowButtonColor(color.hex);
        updateInstagramFeedTabData("popup_follow_button_color", color.hex);
    };

    // Handlers Popup Action Button Color Change
    const handlePopupActionButtonColorChange = (color) => {
        setPopupActionButtonColor(color.hex);
        updateInstagramFeedTabData("popup_action_button_color", color.hex);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateInstagramFeedTabData("custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    return (
        <div className="side-baar-inner-setting">
            {activeSettingTab === "main" && (
                <>
                    <span>Style</span>   
                    <div className="customize-elements-list">
                        <ul>
                            <li><button onClick={() => setActiveSettingTabsElements("header")}>Header <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveSettingTabsElements("post_style")}>Post <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveSettingTabsElements("load_more_button")}>Load More Button <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            {instagramFeedTabData.post_click_action ===  "Open_in_popup" && (
                                <li><button onClick={() => setActiveSettingTabsElements("popup")}>Popup <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            )}
                            <li><button onClick={() => setActiveSettingTabsElements("custom_css")}>Custom CSS <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingTab === "header" && (
                <>
                    <div className="inner-box-layout">
                        <span>  <button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Header Style</span>
                        <h6>Colors</h6>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Header Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={headerBackgroundColor} setColor={setHeaderBackgroundColor} onChangeComplete={handleHeaderBackgroundColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={headerTextColor} setColor={setHeaderTextColor} onChangeComplete={handleHeaderTextColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Follow Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={headerFollowButtonColor} setColor={setHeaderFollowButtonColor} onChangeComplete={handleHeaderFollowButtonColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Follow Button Text Color</span>
                                <div className="color-pikr-box">
                                   <ColorPicker color={headerFollowButtonTextColor} setColor={setHeaderFollowButtonTextColor} onChangeComplete={handleHeaderFollowButtonTextColorChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingTab === "post_style" && (
                <>
                    <div className="inner-box-layout">
                        <span>  <button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Post Style</span>
                        <h6>Colors</h6>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Overlay Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={postOverlayBackgroundColor} setColor={setPostOverlayBackgroundColor} onChangeComplete={handlePostOverlayBackgroundColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Overlay Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={postOverlayTextColor} setColor={setPostOverlayTextColor} onChangeComplete={handlePostOverlayTextColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingTab === "load_more_button" && (
                <>
                    <div className="inner-box-layout">
                        <span>  <button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Load More Button</span>
                        <h6>Colors</h6>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Load More Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={loadMoreButtonColor} setColor={setLoadMoreButtonColor} onChangeComplete={handleLoadMoreButtonColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingTab === "popup" && (
                <>
                    <div className="inner-box-layout">
                        <span>  <button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Popup Style</span>
                        <h6>Colors</h6>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Color Overlay</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupColorOverlayColor} setColor={setPopupColorOverlayColor} onChangeComplete={handlePopupColorOverlayChange}/>
                                </div>
                            </div>
                             <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupBackgroundColor} setColor={setPopupBackgroundColor} onChangeComplete={handlePopupBackgroundColorChange}/>
                                </div>
                            </div>
                             <div className="box-header-row">
                                <span>Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupTextColor} setColor={setPopupTextColor} onChangeComplete={handlePopupTextColorChange}/>
                                </div>
                            </div>
                             <div className="box-header-row">
                                <span>Links Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupLinksColor} setColor={setPopupLinksColor} onChangeComplete={handlePopupLinksColorChange}/>
                                </div>
                            </div>
                             <div className="box-header-row">
                                <span>Follow Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupFollowButtonColor} setColor={setPopupFollowButtonColor} onChangeComplete={handlePopupFollowButtonColorChange}/>
                                </div>
                            </div>
                             <div className="box-header-row">
                                <span>Call to Action Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupActionButtonColor} setColor={setPopupActionButtonColor} onChangeComplete={handlePopupActionButtonColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                        <p>Tip: It is recommended to use the CSS classes with the “es” prefix, as these are specially designed for stable customization. Please note, while these classes are intended to be more static, we cannot guarantee that they will remain unchanged in future updates.</p>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;